module.exports = __webpack_public_path__ + "static/media/letter-footer-right.55815b75.svg";